module.exports = __webpack_public_path__ + "img/mafiaWays2.eebf87f8.png";